// Doughnut Chart
import { Doughnut, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins


export default {
   extends: Doughnut,
   mixins: [reactiveProp],
   data() {
      return {
         gradients:[],
         colors:[],
         options: {
            cutoutPercentage: 70,
            legend: {
               display: false,
               position: 'bottom'
            },
         }
      }
   },
   mounted() {
      this.renderChart(this.chartData, this.options)
   },
}
